// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"85fbf030","56":"6911a01d","93":"95152109","266":"f2ddea2f","537":"074f8759","566":"7dabc78b","629":"96f6e269","798":"f3e9239d"}[chunkId] + ".chunk.js";
};